// DS — jeden kontrakt ładowania trasy (artboard 01 sesji 08; G2-auth-onboarding-07).
//
// Zimne wejście (`RequireAuth`, zanim `/auth/me` odpowie) i każda leniwa trasa
// (`Suspense` w App.tsx) pokazują TO SAMO: powłoka stoi, treść jest szkieletem
// o kształcie Generatora (3 utwory, 6 paczek, 4 style, podgląd 9:16, karta startu).
// Zero słów „Loading” — dla czytnika jest `aria-busy` i niewidoczna etykieta z locale.
//
// `shell`: wariant na zimne wejście, gdy `Layout` jeszcze nie stoi — rysuje ramę
// (logo, nazwy nawigacji z tej samej listy co powłoka, szkielet miernika) bez danych,
// których jeszcze nie ma. Przesuw szkieletu 1,2 s bierze `ds/motion.css`.

import Logo from '../../components/Logo'
import { appNav } from '../../components/appNav'
import { useT } from '../../lib/i18n'
import { Glyph } from '../media/Glyph'
import { Skeleton } from './StatePanel'

function Tiles({ n, ratio }: { n: number; ratio: 'card' | 'thumb' }) {
  return (
    <div className={`rs-tiles rs-tiles-${ratio}`}>
      {Array.from({ length: n }, (_, i) => <Skeleton key={i} variant={ratio} />)}
    </div>
  )
}

export function RouteSkeleton({ shell = false }: { shell?: boolean }) {
  const t = useT()
  const content = (
    <div className="content route-skeleton" role="status" aria-busy="true" data-testid="route-skeleton">
      <span className="sr-only">{t('nav.loadingRoute')}</span>
      <div className="rs-grid" aria-hidden="true">
        <div className="rs-main">
          <Skeleton variant="title" width={180} />
          <div className="rs-step"><Skeleton variant="circle" width={24} height={24} /><Skeleton variant="text" width={120} /></div>
          <Tiles n={3} ratio="card" />
          <div className="rs-step"><Skeleton variant="circle" width={24} height={24} /><Skeleton variant="text" width={150} /></div>
          <Tiles n={6} ratio="card" />
          <div className="rs-step"><Skeleton variant="circle" width={24} height={24} /><Skeleton variant="text" width={90} /></div>
          <Tiles n={4} ratio="thumb" />
        </div>
        <div className="rs-rail">
          <Skeleton variant="thumb" className="rs-preview" />
          <div className="rs-card card card-padded">
            <Skeleton variant="text" width="45%" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="block" />
          </div>
        </div>
      </div>
    </div>
  )
  if (!shell) return content
  return (
    <div className="app is-skeleton">
      <aside className="sidebar" aria-hidden="true">
        <div className="sidebar-logo"><Logo /></div>
        {/* Zimna rama: TRZY pozycje pewne dla każdego konta. „Publikacja" dochodzi dopiero
            z sesyjnej odpowiedzi — obiecana w szkielecie i cofnięta sekundę później byłaby
            podmianą pozycji pod palcem, czyli tym, co plan wyciął. */}
        <div className="nav-group">
          {appNav(false).map((it) => (
            <span key={it.to} className="nav-item">
              <span className="ni-ic"><Glyph name={it.glyph} size={20} tone="current" /></span>
              <span>{t(it.key)}</span>
            </span>
          ))}
        </div>
        <div className="sidebar-spacer" />
        <div className="gem-balance"><Skeleton variant="text" width="60%" /></div>
      </aside>
      <header className="app-topbar-m" aria-hidden="true"><Logo /></header>
      <main className="main">{content}</main>
    </div>
  )
}

export default RouteSkeleton
